<template>
  <div>
    <!-- <language-list
      v-model="params['locale']"
      :isAll="true"
      @input="params['page'] = 1"
    /> -->
    <div class="my-2 mb-4">
      <button class="btn btn-info btn-icon" @click="addItem">
        <span class="ti-plus"></span>
        {{ "add" | setText("Добавить") }}
      </button>
    </div>
    <add-item
      @close="add = false"
      v-if="fields && fields.length && setLink && add === true"
      :fieldsFrom="fields"
      :getList="getList"
      :setLink="setLink"
      :cardLink="cardLink"
    />
    <div>
      <paper-table
        v-if="this.classes.length"
        type="hover"
        :card="cardLink"
        :cardLink="cardLink"
        :data="this.classes"
        :columns="columns"
        :removeItem="removeItem"
      ></paper-table>
    </div>
  </div>
</template>
<script>
import PaperTable from "@/components/PaperTable2";
import { cardGetList } from "@/plugins/functions";
export default {
  props: ["id"],
  components: {
    "paper-table": PaperTable,
    "add-item": () => import("@/components/Modals/AddItem"),
  },
  created() {
    this.getList()
  },
  watch:{
    params: {
      handler(val){
        this.classes = this.items.filter(e=>{return (e.locale == val.locale || val.locale == '')})
      },
      deep: true,
    },
  },
  methods: {
    cardGetList: cardGetList,
    removeItem(itemID){
      this.$dialog
        .confirm("Вы точно хотите удалить?", {
          okText: "Удалить",
          cancelText: "Отмена",
        })
        .then(() => {
          this.$loading(true);
          this.$http
            .post(`${this.itemLink}/${itemID}`, { _method: "DELETE" })
            .then((response) => {
              this.getList();
            })
            .catch((error) => {
              errorNotify(error, this.$notify);
            })
            .finally(() => {
              setTimeout(() => {
                this.$loading(false);
              }, 400);
            });
        })
        .catch(() => {});
    },
    addItem() {
      this.add = true;
    },
    async getList(loading = true, resetPage = false){
      this.itemLink = `${this.$store.state.secApiUrl}/school/subjects/${this.id}/classes`;
      this.setLink = `${this.$store.state.secApiUrl}/school/subjects/${this.id}/classes`;
      this.loading = true;
      if (loading) {
        this.$loading(true);
      }
      this.classes = await this.cardGetList(this.itemLink)
      // this.classes.forEach(e=>{e.course_name = Object.values(this.$store.state.courses).indexOf(e.course_id)})
    }
  },
  data() {
    return {
      classes: [],
      add: false,
      val: [],
      params: {},
      modalCreate: "lessonplan",
      fields: [
        {
          col: "col-12 col-md-6",
          label: "Для классов",
          key: "course_id",
          type: "course",
        },
        {
          col: "col-12 col-md-6",
          key: "locale",
          label: "Локализация контента",
          type: "locale",
          textType: "text",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_books",
      itemLink: "",
      setLink: "",
      columns: [
        {
          key: "course",
          title: "Класс",
          checkbox: false,
          disableLink: true,
          object: "position",
        },
        {
          key: "locale",
          title: "Локализация",
          checkbox: false,
        },
        {
          key: "created_at",
          title: "Создан",
          dateTimeFormat: true,
        },
        {
          detail: true,
          remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
